
import React, { useEffect, useState } from 'react';
import styles from '../components/UpcomingEvents/UpcomingEvents.module.scss';
import Card from "react-bootstrap/Card";
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Container from 'react-bootstrap/Container';
import Button from 'react-bootstrap/Button';
import CustomImage from "./CustomImage"; 
import Breadcrumb from 'react-bootstrap/Breadcrumb';
import Slider from "react-slick";
import NeedGuidance from './NeedGuidance';
import { useRouter } from 'next/router';
import _debounce from 'lodash/debounce'
import fetchUtil from '../utils/fetchUtil';

interface FilterProps {
  city: string;
  studydestination: string;
  eventType: string;
  searchValue: string
}

const PartnerWebinars: React.FC = (props: any) => {
  const [filters, setFilters] = useState<FilterProps>({ city: '', studydestination: '', eventType: '', searchValue: '' })
  const [searchKeyword, setSearchKeyword] = useState<string>('')
  const [searchQuery, setSearchQuery] = useState<any>({});
  const [allWebinars, setAllWebinars] = useState<any>([])
  const [totalCount, setTotalCount] = useState<number>(0)
  const { searchValue } = filters
  const [isViewMore, setIsViewMore] = useState<boolean>(false)
  const router = useRouter()

  const debounceSearchQuery = (searchKeyValue: string) => {
    const search = _debounce(
      () => setFilters({ ...filters, searchValue: searchKeyValue }),
      500
    );
    setSearchQuery((prevSearch: any) => {
      if (prevSearch.cancel) {
        prevSearch.cancel();
      }
      return search;
    });
    search();
  };
  const routeCoundition = router.pathname.includes('university')
  const webinartype = routeCoundition ? 'webinar_by_university_delegate' : 'webinar_by_kc_expert'

  useEffect(() => {
    const search = searchValue ? `&name_contains=${searchValue}` : ''
    const limitCondition = isViewMore ? '' : '&_limit=6'
    fetchUtil(`${process.env.NEXT_PUBLIC_API_BASE_URL}/partner-webinars?webinarType=${webinartype}&_sort=startDate:ASC&_start=0${search}${limitCondition}`, 'GET', {}, '', false)
      .then((res: any) => {
        setAllWebinars(res)
      })
    fetchUtil(`${process.env.NEXT_PUBLIC_API_BASE_URL}/partner-webinars/count?webinarType=${webinartype}&_start=0${search}${limitCondition}`, 'GET', {}, '', false)
      .then((res: any) => {
        setTotalCount(res)
      })
  }, [filters, isViewMore])

  const settings = {
    dots: true,
    infinite: false,
    speed: 500,
    slidesToShow: 3,
    slidesToScroll: 3,
    initialSlide: 0,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 3,
          infinite: true,
          dots: true
        }
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2,
          initialSlide: 2
        }
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          arrows: false
        }
      }
    ]
  };
  return (
    <>
      <div id='part-edtech' className={`${styles.edtech} ${styles.bgColor}`}>
        <Container>
          <div className={styles.breadcrum}>
            <Row className="text-center">
              <Col lg={12} md={12} xs={12} className={styles.centered}>
                <Breadcrumb>
                  <Breadcrumb.Item style={{ opacity: 0.5, color: '#313145' }} href="/">Home</Breadcrumb.Item>
                  <Breadcrumb.Item style={{ color: '#313145' }} href=""> Partner Webinars </Breadcrumb.Item>
                </Breadcrumb>
              </Col>
            </Row>
          </div>
        </Container>
      </div >

      {/* The Event Week */}
      <Container id='event-week-edtech' style={{ position: "relative" }}>
        <div className={styles.theEventweek}>
          <h1 className={styles.titleClass}> All Our Partner Webinars </h1>
        </div>
        <div className={styles.filtersDrop}>
          <Row>
            <Col lg={9} md={9} xs={12} className={styles.filtercheck} >
            </Col>
            <Col lg={3} md={3} xs={12} >
              <form className="navbar-form" role="search">
                <div className="input-group add-on">
                  <div className={styles.inputBox}>
                    <input className="form-control" placeholder="Search Webinars" name="srch-term" id="srch-term" type="text"
                      value={searchKeyword}
                      onChange={(e: any) => {
                        const searchValues = e.target.value
                        debounceSearchQuery(searchValues)
                        setSearchKeyword(searchValues)
                      }}
                    />
                    <div className={styles.inputBtn}>
                      <CustomImage src="/searchco.svg" alt="searchco" width={14} height={14} />
                    </div>
                  </div>
                </div>
              </form>
            </Col>
          </Row>
        </div >
        <div >
          <ul className={`${styles.eventTabs} nav nav-tabs`}>
            <li className="nav-item" >
              <button
                onClick={() => router.push('/partners/webinar-by-university-delegates')}
                type="button"
                className={`nav-link ${routeCoundition ? 'active' : ''}`}>
                Webinars by University
              </button>
            </li>
            <li className="nav-item" >
              <button
                onClick={() => router.push('/partners/webinar-by-kc-admission-experts')}
                type="button"
                className={`nav-link ${routeCoundition ? '' : 'active'}`}>
                Webinars by KC
              </button>
            </li>
          </ul>
        </div>
        <div className="d-none d-sm-block">
          <div className={styles.theEventweek}>
            <Row>
              {allWebinars?.length > 0
                ? allWebinars.map((event: any) => {
                  return (
                    <Col xs={12} md={4} key={event.id}>
                      <Card className={styles.cardCust} style={{ height: "350px" }}>
                        <Card.Img variant="top" src={event.imageUrl} />
                        <Card.Body className={styles.cardBody}>
                          <Card.Text className={styles.textDate} >{event.date} · {event.time}</Card.Text>
                          <Card.Title className={styles.subTitle}>{event.name}</Card.Title>
                          <Button size="lg" className={styles.btEduExpo}
                            onClick={() => router.push(event.registerUrl)}>
                            Register Now
                          </Button>
                        </Card.Body>
                      </Card>
                    </Col>
                  )
                })
                : 'No Webinars'
              }
            </Row>
          </div>
        </div>
        <div className="d-block d-sm-none">
          {allWebinars.length > 0
            ? <div className={styles.theEventweek}>
              {
                allWebinars.map((event: any) => {
                  return (
                    <Slider {...settings}>
                      <div key={event.id}>
                        <Row>
                          <Col xs={12} md={4}>
                            <Card className={styles.cardCust} style={{ height: "350px" }} >
                              <Card.Img variant="top" src={event.imageUrl} />
                              <Card.Body className={styles.cardBody}>
                                <Card.Text className={styles.textDate} >{event.date} · {event.time}</Card.Text>
                                <Card.Title className={styles.subTitle}>{event.name}</Card.Title>
                                <Button size="lg" className={styles.btEduExpo}
                                  onClick={() => router.push(event.registerUrl)}>
                                  Register Now
                                </Button>
                              </Card.Body>
                            </Card>
                          </Col>
                        </Row>
                      </div>
                    </Slider>
                  )
                })
              }
            </div>
            : 'No Webinars'}
        </div>
        {totalCount > 6 && !isViewMore && <Row className={styles.viewMoreContainer}>
          <Col>
            <span onClick={() => setIsViewMore(true)} className={styles.viewMore}> See More </span>
          </Col>
        </Row>}
      </Container >
      <NeedGuidance />
    </>
  )
}

export default PartnerWebinars;
